module.exports = __webpack_public_path__ + "media/applicants/device_signup_7-fr-8f13e0cd.jpg";